<template>
    <div class="roster-summary" v-bind:class="{'loading-roster': loading}" v-bind:style="{'margin-left': GetOffset(false)}">
        <div class="header title">
            <div class="icon-main-md"></div>
            <labelc class="mein" type="dark center large thin" text="MEIN" />
            <labelc class="dientsplan" type="dark center large bold" text="DIENTSPLAN" />
            <labelc type="header center huge bold" :text="dateSelectionStart.locale($i18n.locale).format('MMMM YYYY')" />
        </div>
        <tickertext :state="{textArray: tickerText}"/>
        <datatablepaging :pageLength="pagingLength" :maxItems="dataTableState.data.length" @update="(options) => { pageOptions = options }" />
        <datatable :state="dataTableState" :pageState="pageOptions" @hook:mounted="MountedTable" ref="dataTable"/>
        <div v-if="false" class="loading-md bg">
            <div class="background"></div>
            <i class="fas fa-spinner"></i>
            <div v-if="!$helpers.isEmpty(loadingText)" class="loading-text">
                {{ loadingText }}
            </div>
        </div>

    </div>
</template>


<script>

    import VueEventBus from '../../vue-event-bus';
    import html2canvas from 'html2canvas';

    import { mapState, mapGetters } from 'vuex';


    export default {
        name: 'RosterSummary',
        components: {
        },
        data() {
            return {
                pageOptions:{},
                loading: false,
                loadingText: '',
                showRosterMode: 'plan',
                employeeMapShared: {},
                planShiftMapShared: {},
                employeeAvailabilityMapShared: {},
                spotMapShared: {},
                employeePreferenceMapShared: {},
                loadShared: false,
                employeeMapPaged: null,
            }
        },
        props:{
            roster: Object,
        },
        
        created(){
            let view = this;
            
            this.RefreshFromMaps();

        },
        beforeDestroy(){
        },
        mounted() {
        },
        computed: {
            ...mapGetters([
                'employeeMap',
                'employeePreferenceMap',
                'employeeAvailabilityMap',
                'planShiftMap',
                'rosterFromTo',
                'spotMap',
                'storeId',
                'storeSettings',
            ]),
            dateSelectionStart() {
                if(this.rosterFromTo){
                    return this.$helpers.getMomentFromValuesTZ(this.rosterFromTo.year, this.rosterFromTo.month, 1);
                } else {
                    return this.$helpers.getMomentTZStartOfDay().startOf('month');
                }
            },
            planShiftMomentMap(){
                let view = this;
                let map = {};
                let from = view.$helpers.getMomentFromStringTZ(this.dateSelectionStart.clone().startOf('month'));
                let to = view.$helpers.getMomentFromStringTZ(this.dateSelectionStart.clone().endOf('month'));
                Object.values(this.loadShared ? this.planShiftMapShared : this.planShiftMap).filter(s => s.employeeId && s.published && s.spotId).forEach(s => {
                    let fromDate = view.$helpers.getMomentFromStringTZ(s.from);
                    let toDate = view.$helpers.getMomentFromStringTZ(s.to);
                    if(from < fromDate && to > toDate) {
                        let shift = {};
                        for (let x in s) {
                            shift[x] = s[x];
                        }
                        map[s.id] = shift;
                        shift.fromDate = fromDate
                        shift.toDate = toDate
                    }
                });
                return map;
            },
            employeeDatePublishedShiftMap(){
                let view = this;
                let map = {};
                Object.values(this.loadShared ? this.employeeMapShared : this.employeeMap).forEach(e => {
                    let formatPre = view.dateSelectionStart.format('YYYY-MM-');
                    for(let x = 1; x <=  view.dateSelectionStart.daysInMonth(); x++){
                        let date = x;
                        if(date < 10) date = '0' + date;
                        if(!map[e.id]) map[e.id] = {};
                        map[e.id][formatPre + date] = view.roster.employeeMap[e.id] ? view.roster.employeeMap[e.id].shiftsDate ? view.roster.employeeMap[e.id].shiftsDate[formatPre + date] ? view.roster.employeeMap[e.id].shiftsDate[formatPre + date] : [] : [] : [];
                    }
                });

                /*Object.values(this.planShiftMomentMap).forEach(s => {
                    map[s.employeeId][s.fromDate.format('YYYY-MM-DD')].push(s);
                });*/
                return map;
            },
            pagingLength(){
                let captureHeight = 1920;
                let headerHeight = 200 + 50;
                let tableMargins = 30 * 2;
                let tableHeader = 30;
                let rowHeight = 40;
                return parseInt((captureHeight - headerHeight - tableMargins - tableHeader) / rowHeight);
            },
            tickerText(){
                let text = 'text1 text1 text1 text1 text1 text1';
                let textArray = Array(10).fill(text);
                for(let x in textArray) textArray[x] = textArray[x].split('1').join(x);
                return textArray;
            },
            dataTableState(){
                let view = this;
                let keyLabel = {employee: ''};
                let state = this.$helpers.GetDataTableStateFromKeyLabelObject(keyLabel, Object.values(this.employeeMapPaged ? this.employeeMapPaged : this.loadShared ? this.employeeMapShared : this.employeeMap));

                for(let x = 1; x <=  view.dateSelectionStart.daysInMonth(); x++){
                    let date = view.dateSelectionStart.clone().date(x);
                    state.headerMap[date.format('YYYY-MM-DD')] = {
                        width: '30px',
                        componentTypeColumn: 'headerdate',
                        componentState: {date: date},
                        componentTypeRow: 'rosterday',
                        componentStateBuilder: (employee, entry) => {
                            let top = '';
                            let bottom = '';
                            let format = entry.map.date.format('YYYY-MM-DD');
                            let shifts = view.roster.employeeDatePlannedShiftMap[employee.id][format];
                            if(shifts != null){
                                shifts = shifts.filter(shift => shift.published);
                            } else {
                                shifts = [];
                            }
                            if(shifts.length > 0){
                                bottom = shifts.reduce((highest, current) => { return highest.toDate > current.toDate ? highest : current}).toDate.format('HH:mm');
                                top = shifts.reduce((lowest, current) => { return lowest.fromDate < current.fromDate ? lowest : current}).fromDate.format('HH:mm');
                            }

                            let spotMap = this.loadShared ? this.spotMapShared : this.spotMap;

                            let color = shifts.find(s => spotMap[s.spotId].color);
                            if(color) {
                                color = spotMap[color.spotId].color;
                            }

                            return {
                                top: top,
                                bottom: bottom,
                                date: entry.map.date,
                                icon: view.GetDateIcon(employee, entry.map.date),
                                shifts: shifts,
                                background: color,
                            }
                        },
                        date: date,
                    };
                }

                state.headerMap.employee.label = ' ';
                state.headerMap.employee.width = '120px';
                state.headerMap.employee.componentTypeRow = 'employeeentry';
                state.headerMap.employee.componentStateBuilder = (data, entry) => {
                    return {
                        firstName: data.firstName, lastName: data.lastName, summary: true, splitName: true, employee: data,
                    }
                };

                Object.values(state.headerMap).forEach(h => h.alignLeft = true);
                state.compact = true;
                return state;
            },

            employeePreferenceMomentMap()
            {
                let map = {};
                Object.values(this.loadShared ? this.employeePreferenceMapShared : this.employeePreferenceMap).forEach(entry => {
                    let fromDate = this.$helpers.getMomentFromStringTZ(entry.from);
                    let toDate = this.$helpers.getMomentFromStringTZ(entry.to);
                    map[entry.id] = {fromDate: fromDate, toDate: toDate};

                });
                return map;
            },
            employeePreferenceAvailabilityMap(){
                let map = {};
                Object.values(this.loadShared ? this.employeeMapShared : this.employeeMap).forEach(e => {
                    map[e.id] = {preferences: [], preferencesDate: {}};
                });
                Object.values(this.loadShared ? this.employeePreferenceMapShared : this.employeePreferenceMap).filter(pref => pref.approved).forEach(pref => {
                    let employee = this.loadShared ? this.employeeMapShared[pref.employeeId] : this.employeeMap[pref.employeeId];
                    let fromDate = this.employeePreferenceMomentMap[pref.id] ? this.employeePreferenceMomentMap[pref.id].fromDate : this.$helpers.getMomentFromStringTZ(pref.from);
                    let toDate = this.employeePreferenceMomentMap[pref.id] ? this.employeePreferenceMomentMap[pref.id].toDate : this.$helpers.getMomentFromStringTZ(pref.to);

                    if(employee){
                        if(!map[employee.id]){
                            map[employee.id] = {preferences: [], preferencesDate: {}};
                        }

                        map[employee.id].preferences.push(pref);

                        let daysDiff = toDate.diff(fromDate, 'days') + 1;
                        let tempDate = fromDate.clone();
                        while(toDate > tempDate){
                            let key = tempDate.format('YYYY-MM-DD');
                            if(!map[employee.id].preferencesDate[key]) map[employee.id].preferencesDate[key] = [];
                            let item = {preference: pref, date: tempDate.clone().hours(0).minutes(0)};
                            map[employee.id].preferencesDate[key].push(item);
                            tempDate.add(1, 'days');
                        }
                    }
                });
                Object.values(this.loadShared ? this.employeeAvailabilityMapShared : this.employeeAvailabilityMap).forEach(availability => {
                    let employee = this.loadShared ? this.employeeMapShared[availability.employeeId] : this.employeeMap[availability.employeeId];
                    if(employee){
                        if(!map[employee.id]){
                            map[employee.id] = {preferences: [], preferencesDate: {}};
                        }
                        let entry = map[employee.id];

                        if(!entry.availabilities){
                            entry.availabilities = {}
                        }
                        if(!entry.availabilities[availability.state]){
                            entry.availabilities[availability.state] = [];
                        }
                        entry.availabilities[availability.state].push(availability);

                    }
                });

                return map;
            },
        },
        watch: {
            rosterFromTo(newVal, oldVal) {
                console.log("AAA")
                if (newVal != null) {
                    this.dateSelectionStart = this.$helpers.getMomentFromValuesTZ(this.rosterFromTo.year, this.rosterFromTo.month, 1);
                    console.log("AAA "+this.dateSelectionStart.format())
                }
            },
        },
        methods: {
            GetSnapshots(employees, finishedCallback){
                let view = this;
                let headerMarginToRow = 310;
                let rowHeight = 40;
                
                let rowsPerPage = Math.floor((1920 - headerMarginToRow - rowHeight) / rowHeight);
                
                
                
                if(employees.length < rowsPerPage){
                    employees.sort((a,b) => { return a.lastName + a.firstName > b.lastName + b.firstName ? 1 : -1});
                    view.employeeMapPaged = {};
                    employees.forEach(e => view.employeeMapPaged[e.id] = e);
                    requestAnimationFrame(function(){
                        view.$helpers.GetSnapShot(view.$el, {name: 'Dienstplan_'+view.storeSettings.name+"_" + view.dateSelectionStart.format('MMMMYYYY'), width: 1080, height: 1920}, () =>{
                        
                            if(finishedCallback) finishedCallback();
                        });
                    });
                } else {
                    employees.sort((a,b) => { return a.lastName + a.firstName > b.lastName + b.firstName ? 1 : -1});
                    let employeesPaged = [];
                        
                    for (let i = 0; i < employees.length; i += rowsPerPage)
                       employeesPaged.push(employees.slice(i, i + rowsPerPage));
                    this.SnapshotQueue(employeesPaged, finishedCallback, 1);
                }
            },
            SnapshotQueue(employeesPaged, finishedCallback, page = 1){
                let view = this;
                if(employeesPaged.length === 0) {
                    if(finishedCallback) finishedCallback();
                    return;
                }
                view.employeeMapPaged = {};
                let latest = employeesPaged.shift();
                latest.forEach(e => view.employeeMapPaged[e.id] = e);
                requestAnimationFrame(function(){
                    view.$helpers.GetSnapShot(view.$el, {name: 'Dienstplan_'+view.storeSettings.name+"_" + view.dateSelectionStart.format('MMMMYYYY')+'_'+page, width: 1080, height: 1920}, () =>{
                        view.SnapshotQueue(employeesPaged, finishedCallback, page+1);
                    });
                });
            },
            RefreshFromMaps(){
                let view = this;
                view.$helpers.GetStoreSettings(true).then(response => {
                    return view.$helpers.GetActiveEmployeeMap(true, false, this.storeSettings.hideDeactivatedEmployees);
                }).then(response => {
                        return view.$helpers.GetSpotMap(true);
                }).then(response => {
                        return view.$helpers.GetEmployeeAvailabilityMap(true);
                }).then(response => {
                        return view.$helpers.GetEmployeePreferenceMap(true);
                }).then(response => {
                    return view.$helpers.GetPlanShiftMap(true);
                });
            },
            
            GetOffset(onScreen){
                if(onScreen) return '';
                return window.innerWidth + 'px';
            },
            RenderImage(){
                let view = this;
                this.$helpers.GetSnapShot(this.$el, 'Dienstplan_'+view.storeSettings.name+"_" + view.dateSelectionStart.format('MMMMYYYY'));
            },
            MountedTable(){
                this.CheckTableLoaded();
            },
            CheckTableLoaded(){
                let view = this;
                if($(this.$el).find('.data-table .header-date').length > 0) this.MountedAll();
                else setTimeout(function(){view.CheckTableLoaded()}, 200);
            },
            MountedAll(){
                let view = this;
                //this.$refs.dataTable.$nextTick().then(() => {
                requestAnimationFrame(function(){
                    view.$emit('MountedAll');
                });
            },

            GetDateIcon(employee, date){
                let key = date.format("YYYY-MM-DD");
                //if(this.HasNoContract(employee.id, key)) return 'contains contract';
                if(this.HasSickness(employee.id, key) && date.day() >= 1 && date.day() <= 5) return 'contains sickness';
                if(this.HasVacation(employee.id, key) && date.day() >= 1 && date.day() <= 5) return 'contains vacation'; // Show "X" on weekend instead of the holiday umbrella
                if(this.HasSchooling(employee.id, key) && date.day() >= 1 && date.day() <= 5) return 'contains schooling';
                if(this.HasWageContinuation(employee.id, key)) return 'contains wagecontinuation';
                if(this.HasHolidayAdjustment(employee.id, key)) return 'contains holidayadjustment';
                if(this.HasUnavailable(employee.id, key)) return 'contains unavailable';
            },
            /*HasNoContract(employeeId, date){
                return this.employeeContractStatusMap[date] && this.employeeContractStatusMap[date][employeeId];

            },*/
            HasUnavailable(employeeId, date){
                return this.employeePreferenceAvailabilityMap[employeeId]
                    && this.employeePreferenceAvailabilityMap[employeeId].preferencesDate[date]
                    && this.employeePreferenceAvailabilityMap[employeeId].preferencesDate[date].filter(item => item.preference.state == 1).length > 0
            },

            HasVacation(employeeId, date){
                return this.employeePreferenceAvailabilityMap[employeeId]
                    && this.employeePreferenceAvailabilityMap[employeeId].preferencesDate[date]
                    && this.employeePreferenceAvailabilityMap[employeeId].preferencesDate[date].filter(item => item.preference.type == 1 || item.preference.type == 6).length > 0
            },

            HasSchooling(employeeId, date){
                return this.employeePreferenceAvailabilityMap[employeeId]
                    && this.employeePreferenceAvailabilityMap[employeeId].preferencesDate[date]
                    && this.employeePreferenceAvailabilityMap[employeeId].preferencesDate[date].filter(item => item.preference.type == 7).length > 0
            },

            HasWageContinuation(employeeId, date){
                return this.employeePreferenceAvailabilityMap[employeeId]
                    && this.employeePreferenceAvailabilityMap[employeeId].preferencesDate[date]
                    && this.employeePreferenceAvailabilityMap[employeeId].preferencesDate[date].filter(item => item.preference.type == 8).length > 0
            },

            HasHolidayAdjustment(employeeId, date){
                return this.employeePreferenceAvailabilityMap[employeeId]
                    && this.employeePreferenceAvailabilityMap[employeeId].preferencesDate[date]
                    && this.employeePreferenceAvailabilityMap[employeeId].preferencesDate[date].filter(item => item.preference.type == 3).length > 0
            },

            HasSickness(employeeId, date){
                return this.employeePreferenceAvailabilityMap[employeeId]
                    && this.employeePreferenceAvailabilityMap[employeeId].preferencesDate[date]
                    && this.employeePreferenceAvailabilityMap[employeeId].preferencesDate[date].filter(item => item.preference.type == 2).length > 0

            },
        },
    }
</script>

<style scoped>

    .roster-summary{
        position: fixed !important;
        top: 0;
        left: 0;
        width: 100vw !important;;
        height: 100vh !important;;
        overflow: visible;
        z-index: 1000;
        text-align: center;
        margin-top: 0 !important;
        background: var(--bg);
    }

    .data-table{
        display: inline-block;
        width: fit-content;
        margin-top: 30px;
        pointer-events: none;
    }

    .header.title{
        height: 200px;
        background: var(--bg);
        background: linear-gradient(180deg, var(--bg) 0%, var(--contrast-1) 100%);
    }

    .nightmode .header.title{
        background: var(--bg);
    }


    .header.title{
        padding-top: 20px;
        text-align: center;
    }

    .label.huge{
        margin-top: -20px;
    }

    .label.mein{
        display: inline-block;
        width: fit-content;
        float: none;
        margin: 0;
        margin-right: -5px;
    }

    .label.dientsplan{
        display: inline-block;
        width: fit-content;
        float: none;
        margin: 0;
    }

    .icon-main-md{

        background: url(https://web.meindienstplan.at/images/md-logo.png);
        background-size: 100%;
        background-position: 50%;
        background-repeat: no-repeat;
        height: 25px;
        width: 25px;
        border-radius: 0;
        position: relative;
        display: inline-block;
        margin-right: 10px;
    }

    .loading-md .background{
        opacity: .5;
        background: white;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        position: absolute;
    }
</style>
